module.exports = __webpack_public_path__ + "img/title.ee79eb6d.jpg";